// extracted by mini-css-extract-plugin
module.exports =  {"phone":"a10a3f92e9--phone--BExj8"};